import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-530d3a55"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"20%"} }, "1", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"5px"} }, "任务名称 / 编码", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"5px"} }, "项目名称 / 编码", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"5px"} }, "任务执行区域", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"5px"} }, "任务类型", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"5px"} }, "报名截止时间", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"5px"} }, "发布人", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"5px"} }, "发布时间", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"5px"} }, "任务状态", -1))
const _hoisted_10 = { style: {"margin-top":"20px","background":"#fff","padding":"0 30px 20px","border-radius":"4px"} }
const _hoisted_11 = { class: "serialNumber" }
const _hoisted_12 = { class: "terminalNameContainer" }
const _hoisted_13 = { class: "iconbox" }
const _hoisted_14 = { href: "javascript:" }
const _hoisted_15 = { class: "terminalNameBox longBox" }
const _hoisted_16 = ["onClick", "title"]
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "terminalNameContainer" }
const _hoisted_19 = { class: "terminalNameBox longBox" }
const _hoisted_20 = ["title"]
const _hoisted_21 = ["title"]
const _hoisted_22 = { class: "terminalNameContainer" }
const _hoisted_23 = { class: "terminalNameBox longBox" }
const _hoisted_24 = ["title"]
const _hoisted_25 = ["title"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = ["title"]
const _hoisted_29 = { class: "buttonBox" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "编辑", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stick" }, "|", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "删除", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "终止", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_Screen = _resolveComponent("Screen")!
  const _component_TableTab = _resolveComponent("TableTab")!
  const _component_TagsFilled = _resolveComponent("TagsFilled")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Screen, {
      onSearch: _ctx.search,
      onReset: _ctx.reset
    }, {
      "1": _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_a_input, {
          class: "input",
          value: _ctx.taskInfoTitleOrCode,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.taskInfoTitleOrCode) = $event)),
          placeholder: "请输入...",
          onKeyup: _withKeys(_ctx.search, ["enter"]),
          allowClear: ""
        }, null, 8, ["value", "onKeyup"])
      ]),
      "2": _withCtx(() => [
        _hoisted_3,
        _createVNode(_component_a_input, {
          class: "input",
          value: _ctx.prjNameOrCode,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.prjNameOrCode) = $event)),
          placeholder: "请输入...",
          onKeyup: _withKeys(_ctx.search, ["enter"]),
          allowClear: ""
        }, null, 8, ["value", "onKeyup"])
      ]),
      "3": _withCtx(() => [
        _hoisted_4,
        _createVNode(_component_a_select, {
          placeholder: "请选择...",
          style: {"width":"100%"},
          value: _ctx.taskDimension,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.taskDimension) = $event)),
          options: _ctx.taskDimensionOptions,
          optionFilterProp: "label",
          allowClear: ""
        }, null, 8, ["value", "options"])
      ]),
      "4": _withCtx(() => [
        _hoisted_5,
        _createVNode(_component_a_select, {
          placeholder: "请选择...",
          style: {"width":"100%"},
          value: _ctx.typeCode,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.typeCode) = $event)),
          options: _ctx.typeCodeOptions,
          optionFilterProp: "label",
          allowClear: ""
        }, null, 8, ["value", "options"])
      ]),
      "5": _withCtx(() => [
        _hoisted_6,
        _createVNode(_component_a_range_picker, {
          value: _ctx.rangePicker2,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rangePicker2) = $event)),
          onCalendarChange: _ctx.onCalendarChange,
          onOpenChange: _ctx.onOpenChange,
          allowClear: ""
        }, null, 8, ["value", "onCalendarChange", "onOpenChange"])
      ]),
      "6": _withCtx(() => [
        _hoisted_7,
        _createVNode(_component_a_input, {
          class: "input",
          value: _ctx.publishName,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.publishName) = $event)),
          placeholder: "请输入...",
          onKeyup: _withKeys(_ctx.search, ["enter"]),
          allowClear: ""
        }, null, 8, ["value", "onKeyup"])
      ]),
      "7": _withCtx(() => [
        _hoisted_8,
        _createVNode(_component_a_range_picker, {
          disabledDate: _ctx.disabledDate,
          value: _ctx.rangePicker,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.rangePicker) = $event)),
          onCalendarChange: _ctx.onCalendarChange,
          onOpenChange: _ctx.onOpenChange,
          allowClear: ""
        }, null, 8, ["disabledDate", "value", "onCalendarChange", "onOpenChange"])
      ]),
      "8": _withCtx(() => [
        _hoisted_9,
        _createVNode(_component_a_select, {
          placeholder: "请选择...",
          style: {"width":"100%"},
          value: _ctx.taskStatus,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.taskStatus) = $event)),
          options: _ctx.taskStatusOptions,
          optionFilterProp: "label",
          allowClear: ""
        }, null, 8, ["value", "options"])
      ]),
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["onSearch", "onReset"]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", null, [
        _createVNode(_component_TableTab, {
          tabName: "任务列表",
          onSearch: _ctx.search,
          onAdd: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toDetails())),
          addBtn: true,
          columns: _ctx.columns
        }, null, 8, ["onSearch", "columns"]),
        _createVNode(_component_a_table, {
          rowKey: "id",
          columns: _ctx.columns,
          "data-source": _ctx.data,
          pagination: false,
          scroll: _ctx.scroll,
          loading: _ctx.loading,
          size: _ctx.$store.state.batchStyle
        }, {
          serialNumber: _withCtx(({ index }) => [
            _createElementVNode("span", _hoisted_11, _toDisplayString(index + 1), 1)
          ]),
          taskTitle: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("a", _hoisted_14, [
                  _createVNode(_component_TagsFilled)
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (_ctx.toPreview(record.id)),
                    href: "javascript:",
                    class: "terminalName",
                    title: record.taskTitle,
                    style: {"text-decoration":"underline"}
                  }, _toDisplayString(record.taskTitle), 9, _hoisted_16)
                ]),
                _createElementVNode("div", {
                  class: "terminalNameBox longBox",
                  style: {"color":"#ccc"},
                  title: record.taskCode
                }, _toDisplayString(record.taskCode), 9, _hoisted_17)
              ])
            ])
          ]),
          prjName: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", {
                    href: "javascript:",
                    class: "terminalName",
                    title: record.prjName
                  }, _toDisplayString(record.prjName), 9, _hoisted_20)
                ]),
                _createElementVNode("div", {
                  class: "terminalNameBox longBox",
                  style: {"color":"#ccc"},
                  title: record.prjCode
                }, _toDisplayString(record.prjCode), 9, _hoisted_21)
              ])
            ])
          ]),
          terminalName: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", {
                    href: "javascript:",
                    class: "terminalName",
                    title: record.terminalName
                  }, _toDisplayString(record.terminalName), 9, _hoisted_24)
                ]),
                _createElementVNode("div", {
                  class: "terminalNameBox longBox",
                  style: {"color":"#ccc"},
                  title: record.terminalCode
                }, _toDisplayString(record.terminalCode), 9, _hoisted_25)
              ])
            ])
          ]),
          province: _withCtx(({ record }) => [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(record.province) + " ", 1),
                (record.city)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, "/"))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(record.city) + " ", 1),
                (record.area)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, "/"))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(record.area) + " ", 1)
              ]),
              _createElementVNode("div", {
                class: "terminalNameBox",
                title: record.address
              }, [
                _createElementVNode("span", null, _toDisplayString(record.address), 1)
              ], 8, _hoisted_28)
            ])
          ]),
          handle: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_29, [
              (
                  record.taskStatus == '编辑中' || record.taskStatus == '待领取'
                )
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "text",
                    class: "firstButton",
                    onClick: ($event: any) => (_ctx.toDetails(record.id))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_30
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    type: "text",
                    class: "firstButton",
                    onClick: ($event: any) => (_ctx.toPreview(record.id))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_31
                    ]),
                    _: 2
                  }, 1032, ["onClick"])),
              _hoisted_32,
              (record.taskStatus == '编辑中')
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 2,
                    disabled: "",
                    type: "text",
                    class: "lastButton",
                    onClick: ($event: any) => (_ctx.handleDeleteBrand(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_33
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : (_openBlock(), _createBlock(_component_a_button, {
                    key: 3,
                    disabled: "",
                    type: "text",
                    class: "lastButton",
                    onClick: ($event: any) => (_ctx.handleDeleteBrand(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_34
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
            ])
          ]),
          _: 1
        }, 8, ["columns", "data-source", "scroll", "loading", "size"])
      ]),
      _createVNode(_component_Pagination, {
        total: _ctx.total,
        onChange: _ctx.changePagination
      }, null, 8, ["total", "onChange"])
    ])
  ]))
}